import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@upme/ui/components/button';
import { ProvidersTable } from '../../../features/payment-providers/components/providers-table';
import { useDeleteProvider } from '../../../features/payment-providers/mutations';
import { listProvidersOptions } from '../../../features/payment-providers/queries';

export const Route = createFileRoute('/_authenticated/payment-providers/')({
  loader: ({ context }) => context.queryClient.ensureQueryData(listProvidersOptions()),
  component: ProvidersIndexPage,
});

function ProvidersIndexPage() {
  const { data: providers } = useSuspenseQuery(listProvidersOptions());
  const del = useDeleteProvider();

  return (
    <div className="space-y-4 p-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold">Провайдеры платежей</h1>
        <Button asChild>
          <Link to="/payment-providers/new">Добавить</Link>
        </Button>
      </div>
      <ProvidersTable providers={providers} onDelete={(id) => del.mutate(id)} />
    </div>
  );
}
